type StoreConfig = {
  shopify: {
    handle: string;
    url: string;
    region: string;
    appSubpath: string;
  };
  storefront: {
    accessToken: string;
    apiVersion: string;
  };
  searchspring: {
    collections: string;
    products: string;
    pages: string;
  };
  klaviyo: {
    id: string;
    apiVersion: string;
  };
  validation?: {
    phone: {
      prefix: string;
      pattern: string;
    };
  };
};

function defineStoreConfig(config: StoreConfig) {
  return config;
}

export const config = {
  keys: {
    announcement: "announcement",
  },
  attributes: {
    gift: "giftWithPurchase",
  },
  stores: {
    "kathmandu-au": defineStoreConfig({
      shopify: {
        handle: "kathmandu-au",
        url: "https://kathmandu-au.myshopify.com",
        region: "AU",
        appSubpath: "/apps/cloud",
      },
      storefront: {
        accessToken: "",
        apiVersion: "",
      },
      searchspring: {
        collections: "",
        products: "",
        pages: "",
      },
      klaviyo: {
        id: "",
        apiVersion: "2025-04-15",
      },
    }),
    "kathmandu-au-dev": defineStoreConfig({
      shopify: {
        handle: "kathmandu-au-dev",
        url: "https://kathmandu-au-dev.myshopify.com",
        region: "AU",
        appSubpath: "/apps/cloud",
      },
      storefront: {
        accessToken: "",
        apiVersion: "",
      },
      searchspring: {
        collections: "",
        products: "",
        pages: "",
      },
      klaviyo: {
        id: "",
        apiVersion: "2025-04-15",
      },
    }),
    "kathmandu-nz": defineStoreConfig({
      shopify: {
        handle: "kathmandu-nz",
        url: "https://kathmandu-nz.myshopify.com",
        region: "NZ",
        appSubpath: "/apps/cloud",
      },
      storefront: {
        accessToken: "a3739fb9141363b2194701c8beb0cc39",
        apiVersion: "2025-01",
      },
      searchspring: {
        collections: "0wsr6y",
        products: "0wsr6y",
        pages: "0wsr6y",
      },
      klaviyo: {
        id: "Y4tDF9",
        apiVersion: "2025-04-15",
      },
      validation: {
        phone: {
          prefix: "+64",
          pattern: "+99 99 999 9999",
        },
      },
    }),
    "kathmandu-nz-dev": defineStoreConfig({
      shopify: {
        handle: "kathmandu-nz-dev",
        url: "https://kathmandu-nz-dev.myshopify.com",
        region: "NZ",
        appSubpath: "/apps/cloud",
      },
      storefront: {
        accessToken: "77dcb8aa93da81c3cb0de594946124e0",
        apiVersion: "2025-01",
      },
      searchspring: {
        collections: "ft1lhx",
        products: "ft1lhx",
        pages: "ft1lhx",
      },
      klaviyo: {
        id: "SwZ9Ap",
        apiVersion: "2025-04-15",
      },
    }),
  },
} as const;

type StoreHandle = keyof typeof config.stores;

export function getStoreConfig(handle: StoreHandle) {
  return config.stores[handle];
}

export function getCurrentStoreConfig() {
  const handle = window.SHOPIFY_DATA.shop.handle as StoreHandle;
  return getStoreConfig(handle);
}
